import { useEffect, useState } from "react";
import { get } from "../../redux/ApiHelper";
import TableComponent from "../../components/table/TableComponent";
import { Column } from "../../interfaces/table.interface";
import { GroupClassInterface } from "../../interfaces/group-class.interface";

const GroupClassByTeacher = () => {
  const [originalList, setOriginalList] = useState<GroupClassInterface[]>([]);
  const [groupClassList, setGroupClassList] = useState<GroupClassInterface[]>(
    []
  );
  const [searchQuery, setSearchQuery] = useState("");
  useEffect(() => {
    get("/admin/group-class/get-all").then((res) => {
      setOriginalList(res);
      setGroupClassList(res);
    });
  }, []);

  const handleSearch = (query: string) => {
    setSearchQuery(query);

    if (!query.trim()) {
      setGroupClassList(originalList);
      return;
    }

    const filteredList = originalList.filter((groupClass) => {
      const lowerQuery = query.toLowerCase();

      return (
        groupClass.teacher?.toLowerCase().includes(lowerQuery) ||
        groupClass.location?.toLowerCase().includes(lowerQuery) ||
        groupClass.pin?.toString().includes(lowerQuery) ||
        groupClass.status?.toLowerCase().includes(lowerQuery) ||
        groupClass.mode?.toLowerCase().includes(lowerQuery) ||
        groupClass.subject?.some((subj) =>
          subj.toLowerCase().includes(lowerQuery)
        ) ||
        groupClass.classesToTeach?.some((cls) =>
          cls.toLowerCase().includes(lowerQuery)
        ) ||
        groupClass.board?.some((b) => b.toLowerCase().includes(lowerQuery)) ||
        groupClass.features?.some((feat) =>
          feat.toLowerCase().includes(lowerQuery)
        ) ||
        groupClass.description?.toLowerCase().includes(lowerQuery) ||
        groupClass.header?.toLowerCase().includes(lowerQuery)
      );
    });

    setGroupClassList(filteredList);
  };

  const columns: Column[] = [
    { select: "teacher", header: "Teacher ID", align: "left" },
    { select: "location", header: "Location", align: "left" },
    { select: "pin", header: "Pin Code", align: "left" },
    { select: "status", header: "Status", align: "center" },
    { select: "mode", header: "Mode", align: "center" },
    { select: "feesPerMonth", header: "Fees/Month (INR)", align: "right" },
    {
      select: "avgRating",
      header: "Avg Rating",
      render: (value) =>
        `${value?.value?.toFixed(1) || 0} ★ (${value?.count || 0})`,
      align: "center",
    },
    {
      select: "subject",
      header: "Subjects",
      render: (subjects) => subjects?.join(", ") || "N/A",
    },
    {
      select: "classesToTeach",
      header: "Classes",
      render: (classes) => classes?.join(", ") || "N/A",
    },
    {
      select: "board",
      header: "Boards",
      render: (boards) => boards?.join(", ") || "N/A",
    },
    {
      select: "features",
      header: "Features",
      render: (features) =>
        features?.length ? (
          <ul className="list-disc pl-5">
            {features.map((f: string, i: number) => (
              <li key={i}>{f}</li>
            ))}
          </ul>
        ) : (
          "N/A"
        ),
    },
    {
      select: "availableVacancy",
      header: "Vacancy",
      align: "center",
    },
    {
      select: "seatsForEachGroup",
      header: "Seats/Group",
      align: "center",
    },
  ];

  return (
    <div className="parent table-container">
      <div className="title">Group class list created by teachers</div>
      <div className="search-container mb-4">
        <input
          type="text"
          className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm"
          placeholder="Group class"
          value={searchQuery}
          onChange={(e) => handleSearch(e.target.value)}
        />
      </div>
      <TableComponent columns={columns} data={groupClassList} />
    </div>
  );
};

export default GroupClassByTeacher;
